module.exports = __webpack_public_path__ + "img/HC2022-38.4f9c1b7a.jpg";